
<template>
  <a-card :bordered="false">
    <component @onEdit="handleEdit" @onGoBack="handleGoBack" :record="record" :is="currentComponent"></component>
  </a-card>
</template>

<script>

import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
// 动态切换组件
import List from '@/views/a-trade/credit_letter/lc_issue/table/List'

export default {
  name: 'LcApplication',
  components: {
    AInput,
    ATextarea,
    List
  },
  data () {
    return {
      currentComponent: 'List',
      record: ''
    }
  },
  methods: {
    handleEdit (record) {
      this.record = record || ''
      this.currentComponent = 'Edit'
      console.log(record)
    },
    handleGoBack () {
      this.record = ''
      this.currentComponent = 'List'
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponent = 'List'
    }
  }
}
</script>
